let env = process.env.REACT_APP_ENV;

const appConfig = {
  apiPrefix:
    env === "dev"
      ? "https://dev-student-api.thestudentsvisa.com/api"
      : env === "tst"
      ? "https://student-api.tst.thestudentsvisa.com/api"
      : "http://localhost:8080/api",
  authenticatedEntryPath: "/app/user-feed",
  unAuthenticatedEntryPath: "/sign-in",
  publicRoute: "/",
  enableMock: true,
  appBackendUrl:
    env === "dev"
      ? "https://dev-student-api.thestudentsvisa.com/api/"
      : env === "tst"
      ? "https://student-api.tst.thestudentsvisa.com/api/"
      : "http://localhost:8080/",
};

export default appConfig;
